<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer></v-spacer>
      <div class="d-flex justify-end align-center mr-3">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca usuarios por email"
          solo
          hide-details
          rounded
          flat
          dense />
      </div>
      <v-dialog @keydown.esc="createDialog=false" v-model="createDialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn
            data-cy="addUser"
            v-if="restaurantId && userPermissions['create-user']"
            v-on="on"
            fab
            x-small
            depressed
            color="primary"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{!form.data.uuid ? 'Crear usuario' : 'Editar usuario'}}</span>
          </v-card-title>
          <v-card-text class="scrollable">
            <v-form ref="userForm" v-model="form.valid">
              <v-container grid-list-xl>
                <v-layout wrap>
                  <v-flex xs6 md6 class="px-4">
                    <v-text-field
                      data-cy="email-restaurant"
                      v-model="form.data.email"
                      :rules="form.rules.email"
                      label="Email"
                      :disabled="isEditing"
                      required>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="px-4">
                    <v-select
                      data-cy="role-restaurant"
                      label="Role"
                      v-model="form.data.role"
                      :rules="form.rules.role"
                      :items="roles"
                      item-text="text"
                      item-value="value"
                      required>
                      <template v-slot:item="{ item }">
                        <v-tooltip
                          right
                          max-width="200">
                          <template v-slot:activator="{ on }">
                            <v-list-item v-on="on">
                              {{ item.text }}
                            </v-list-item>
                          </template>
                          <span>
                            {{ item.hint }}
                          </span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex xs6 md6 class="px-4">
                    <v-select
                      label="Puesto"
                      v-model="form.data.employment"
                      :items="employments"
                      item-text="text"
                      item-value="value">
                      <template v-slot:item="{ item }">
                        <v-tooltip
                          right
                          max-width="200">
                          <template v-slot:activator="{ on }">
                            <v-list-item v-on="on">
                              {{ item.text }}
                            </v-list-item>
                          </template>
                          <!-- <span>
                            {{ item.hint }}
                          </span> -->
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex md12>
                    <v-expansion-panels accordion>
                      <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-menu-down" data-cy="permission">
                          Areas del usuario
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div v-for="(area, index) in areas" :key="`area-${index}`">
                            <v-checkbox
                              v-model="permissionsForm['areas-allowed']"
                              :label="area.name"
                              :value="area._id"
                              :disabled="disableLastOne(area)"
                              multiple
                              hide-details
                              color="primary"
                            />
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-menu-down" data-cy="permission">
                          Ver permisos del usuario
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div
                            v-for="(permission, index) in availablePermissions"
                            :key="`permission-${index}`">
                            <div>
                              <v-checkbox
                                data.cy="purchase-sideMenu"
                                v-model="permissionsForm[permission.module].visible"
                                :label="permission.label"
                                color="primary"
                                hide-details
                                @change="checkModule({ module: permission.module }, $event)"
                              />
                            </div>
                            <div v-if="permission.components.length">
                              <v-divider class="mt-3"/>
                              <div class="pl-4 pt-3">
                                Componentes:
                              </div>
                              <div
                                v-for="(component, index) in permission.components"
                                :key="`component-${index}`"
                                class="pl-4">
                                <div>
                                  <v-checkbox
                                    v-model="permissionsForm[permission.module].components[component.component].visible"
                                    :label="component.label"
                                    color="primary"
                                    hide-details
                                    :disabled="!permissionsForm[permission.module].visible"
                                    @change="checkComponent({ module: permission.module, component: component.component }, $event)"
                                  />
                                </div>
                                <div v-if="component.actions.length">
                                  <div class="pl-4 pt-4">
                                    Acciones:
                                  </div>
                                  <div
                                    v-for="(action, index) in component.actions"
                                    :key="`action-${index}`"
                                    class="pl-4">
                                    <v-checkbox
                                      v-model="permissionsForm[permission.module].components[component.component].actions[action.action]"
                                      :label="action.label"
                                      color="primary"
                                      :disabled="!permissionsForm[permission.module].components[component.component].visible"
                                      hide-details
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="sticky">
            <v-spacer></v-spacer>
            <v-btn color="error" small @click="onCloseCreateDialog">Cerrar</v-btn>
            <v-btn color="primary" small @click="submit" data-cy="submit">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-flex xs12>
      <v-data-table
        v-if="restaurantId"
        loading-text="Cargando users"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        sort-by="email"
        :footer-props="{
          'items-per-page-options': [10, 15, 30, 50]
        }"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:item.role="{ item }">
          <div>
            {{ getRole(item.role) }}
          </div>
          <div class="caption grey--text">
            <span v-if="item.employment">
              {{ getEmployment(item.employment) }}
            </span>
            <span v-else>
              -
            </span>
          </div>
        </template>
        <template v-slot:item.lastLogin="{ item }">
          {{ item.lastLogin | toDateTime }}
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex justify-end align-center">
            <v-tooltip v-if="item.invitation && userPermissions['resend-restaurant-invitation']" left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="info"
                  class="mr-2"
                  v-on="on"
                  @click="onOpenInviteUserDialog(item)">
                  <v-icon>mdi-email</v-icon>
                </v-btn>
              </template>
              <span>Reenviar invitación</span>
            </v-tooltip>
            <v-tooltip v-if="userPermissions['update-user']" left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="primary"
                  class="mr-2"
                  v-on="on"
                  @click="onOpenUpdateUserDialog(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar usuario</span>
            </v-tooltip>
            <v-tooltip v-if="userPermissions['delete-user']" left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="error"
                  v-on="on"
                  @click="onOpenRemoveUserDialog(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar usuario</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <v-flex
        v-else
        class="justify-center d-flex">
        <div class="title">
          Selecciona un restaurant para ver sus usuarios
        </div>
      </v-flex>
    </v-flex>

    <v-dialog @keydown.esc="removeDialog=false" v-model="removeDialog" persistent max-width="max-content">
      <v-card>
        <v-card-title>
          <span class="headline">¿Deseas eliminar a: {{ this.form.data.email }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small @click="onCloseRemoveDialog">No</v-btn>
          <v-btn color="primary" small @click="remove">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="inviteDialog=false" v-model="inviteDialog" persistent max-width="max-content">
      <v-card>
        <v-card-title>
          <span class="headline">¿Deseas enviar una invitación a: {{ this.form.data.email }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small @click="onCloseInviteDialog">No</v-btn>
          <v-btn color="primary" small @click="invite">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="999999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import { cloneDeep, debounce } from 'lodash'

export default {
  name: 'Users',
  data () {
    return {
      createDialog: false,
      removeDialog: false,
      inviteDialog: false,
      roles: [
        {
          text: 'Almacenista',
          value: 'stockmanager',
          hint: 'El almacenista tendrá acceso a ver las órdenes de compra y a capturar el inventario.'
        },
        {
          text: 'Chef',
          value: 'chef',
          hint: 'El chef podrá ver y editar recetas, subrecetas y combos, revisar el menú del restaurante, administrar la producción de subrecetas y capturar inventario.'
        },
        {
          text: 'Comprador',
          value: 'buyer',
          hint: 'El comprador tiene acceso a prospectar ventas, crear y revisar órdenes de compra, usar el módulo de compra inteligente, ver anlásis de inventario y capturar inventario.'
        },
        {
          text: 'Administrador general',
          value: 'manager',
          hint: 'El administrador general tiene acceso a todas las opciones de la plataforma, ver y editar recetas, usar módulo de compras, ver análisis de inventario y capturarlo, configurar restaurante y ver sección de ventas.'
        },
        {
          text: 'Vendedor',
          value: 'seller',
          hint: 'El vendedor tiene acceso sólamente a ver las ventas a domicilio y el balance de ventas.'
        },
        {
          text: 'Financiero',
          value: 'financier',
          hint: '[ TBD. ]'
        }
      ],
      employments: [
        {
          text: 'Administración y tesorería',
          value: 'administration_treasury'
        },
        {
          text: 'Gerencia ejecutiva y operativa',
          value: 'executive_operational'
        },
        {
          text: 'Compras y costos',
          value: 'purchases_costs'
        }
      ],
      overlay: false,
      section: this.$i18n.t('menu.settings.users'),
      table: {
        title: 'Loading users',
        loading: true,
        headers: [
          { text: 'Email', value: 'email' },
          { text: 'Role', value: 'role', sortable: false },
          { text: 'Última conexión', value: 'lastLogin', sortable: false },
          { text: '', value: 'action', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          itemsPerPage: 15,
          page: 1
        }
      },
      form: {
        valid: false,
        data: {
          email: null,
          role: null,
          invitation: null,
          employment: null
        },
        rules: {
          role: [v => !!v || this.$t('validations.role')],
          email: [
            v => !!v || this.$t('validations.email.required'),
            v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) || this.$t('validations.email.valid')
          ]
        }
      },
      permissionsForm: {
        'areas-allowed': [],
        notifications: {
          visible: true,
          components: {
            orders: {
              visible: true,
              actions: {
                'purchases-orders-received-without-invoice': false,
                'resent-purchase-order-email-to-provider': false
              }
            },
            recipes: {
              visible: true,
              actions: {
                'change-price-recipe': false
              }
            },
            providers: {
              visible: true,
              actions: {
                'reminder-new-providers': false
              }
            }
          }
        },
        'recipe-book': {
          visible: false,
          components: {
            menu: {
              visible: false,
              actions: {
                'update-menu': false
              }
            }
          }
        },
        'purchase-orders': {
          visible: true,
          components: {
            'purchase-orders-list': {
              visible: true,
              actions: {
                'read-purchase-orders': true,
                'change-purchase-order-status-to-sent': true,
                'change-purchase-order-status-to-confirmed': true,
                'upload-purchase-order-invoice': true,
                'change-purchase-order-status-to-received': true,
                'change-purchase-order-status-to-cancelled': true,
                'change-purchase-order-status-to-paid': true,
                'copy-purchase-order-link': true,
                'change-purchase-order-update-product-quantity-confirmed': true,
                'delete-purchase-order-product': true,
                'upload-credit-note': true,
                'generate-purchase-order-report': true,
                'change-purchase-order-area': true
              }
            },
            'manual-purchase-orders-form': {
              visible: true,
              actions: {
                'create-purchase-order-by-xml': true,
                'create-purchase-order-template': true,
                'read-purchase-order-template': true,
                'create-purchase-order-by-products': true,
                'create-purchase-order-by-provider-products': true
              }
            },
            'smart-purchase-orders-form': {
              visible: true,
              actions: {
                'create-purchase-order-by-stock': true,
                'create-favorite-purchase-order-product': true
              }
            }
          }
        },
        'my-management': {
          visible: true,
          components: {
            'add-balance': {
              visible: true,
              actions: {
                'increase-balance': true,
                'read-scheduled-deposits': true,
                'manage-balance': true
              }
            },
            'purchases-generated-list': {
              visible: true,
              actions: {
                'export-purchases-report': true
              }
            },
            'movements-list': {
              visible: true,
              actions: {
                'export-movements-report': true,
                'download-xml-zip': true
              }
            }
          }
        },
        'settings': {
          visible: true,
          components: {
            'areas': {
              visible: true,
              actions: {
                'create-area': true,
                'update-area': true,
                'delete-area': true
              }
            },
            'sections': {
              visible: true,
              actions: {
                'create-section': true,
                'update-section': true,
                'delete-section': true
              }
            },
            'users': {
              visible: true,
              actions: {
                'create-user': true,
                'update-user': true,
                'delete-user': true,
                'resend-restaurant-invitation': true
              }
            },
            'restaurant': {
              visible: true,
              actions: {
                'social-network': true,
                'change-restaurant-information': true,
                // 'purchase-orders-notification': true,
                'change-restaurant-tax-information': true,
                'delivery-address': true
              }
            }
          }
        },
        'expenses': {
          visible: true,
          components: {
            'bank-accounts': {
              visible: true,
              actions: {
                'create-bank': true,
                'update-bank': true,
                'create-bank-account': true,
                'link-bank-account': true
              }
            },
            'income-category': {
              visible: true,
              actions: {
                'create-income-category': true,
                'update-income-category': true,
                'create-income-concept': true,
                'update-income-concept': true,
                'create-income-type': true,
                'update-income-type': true
              }
            },
            'outgoing-category': {
              visible: true,
              actions: {
                'create-outgoing-category': true,
                'update-outgoing-category': true,
                'create-outgoing-concept': true,
                'update-outgoing-concept': true,
                'create-outgoing-type': true,
                'update-outgoing-type': true
              }
            },
            'financial-movements': {
              visible: true,
              actions: {
                'create-pay-order': true,
                'add-product-service': true,
                'submit-pay-order': true,
                'download-invoices': true,
                'relate-pay-order': true,
                'generate-pay-order': true,
                'create-movement': true,
                'delete-movement': true,
                'delete-pay-order': true,
                'create-related-transaction': true,
                'delete-related-transaction': true
              }
            },
            'payment-methods': {
              visible: true,
              actions: {
                'create-payment-method': true,
                'update-payment-method': true
              }
            },
            'cash-close': {
              visible: true,
              actions: {
                'create-cashClose': true,
                'update-cashClose': true,
                'validate-status': true,
                'validate-definitive-status': true,
                'edit-amount': false
              }
            },
            'billing': {
              visible: true,
              actions: {
                'create-posSales': true,
                'generate-global-invoice': true,
                'update-posSale': true,
                'generate-document': true
              }
            }
          }
        }
      },
      availablePermissions: [
        {
          module: 'notifications',
          label: 'Recibir notificaciones',
          components: [
            {
              component: 'orders',
              label: 'Ordenes de compra',
              actions: [
                {
                  action: 'purchases-orders-received-without-invoice',
                  label: 'Ordenes de compra recibidas sin factura'
                },
                {
                  action: 'resent-purchase-order-email-to-provider',
                  label: 'Reenviar correo a proveedor de nueva orden de compra.'
                }
              ]
            },
            {
              component: 'recipes',
              label: 'Recetas',
              actions: [
                {
                  action: 'change-price-recipe',
                  label: 'Cambio de precio en receta'
                }
              ]
            },
            {
              component: 'providers',
              label: 'Proveedores',
              actions: [
                {
                  action: 'reminder-new-providers',
                  label: 'Nuevo proveedor'
                }
              ]
            }
          ]
        },
        {
          module: 'recipe-book',
          label: 'Recetario',
          components: [
            {
              component: 'menu',
              label: 'Menu',
              actions: [
                {
                  action: 'update-menu',
                  label: 'Actualizar menu'
                }
              ]
            }
          ]
        },
        {
          module: 'purchase-orders',
          label: 'Órdenes de compra en menú lateral',
          components: [
            {
              component: 'purchase-orders-list',
              label: 'Órdenes de compra',
              actions: [
                {
                  action: 'read-purchase-orders',
                  label: 'Ver detalle de órdenes de compra'
                },
                {
                  action: 'change-purchase-order-status-to-sent',
                  label: 'Enviar órdenes de compra al proveedor'
                },
                // {
                //   action: 'change-purchase-order-status-to-confirmed',
                //   label: 'Confirmar órdenes de compra'
                // },
                {
                  action: 'upload-purchase-order-invoice',
                  label: 'Subir factura'
                },
                {
                  action: 'change-purchase-order-status-to-received',
                  label: 'Recibir mercancía'
                },
                {
                  action: 'change-purchase-order-status-to-cancelled',
                  label: 'Cancelar orden de compra'
                },
                {
                  action: 'change-purchase-order-status-to-paid',
                  label: 'Marcar orden como pagada'
                },
                {
                  action: 'copy-purchase-order-link',
                  label: 'Copiar link de orden de compra'
                },
                {
                  action: 'change-purchase-order-update-product-quantity-confirmed',
                  label: 'Cambiar producto de la orden de compra'
                },
                {
                  action: 'delete-purchase-order-product',
                  label: 'Borrar productos de la orden de compra'
                },
                {
                  action: 'upload-credit-note',
                  label: 'Subir nota de crédito'
                },
                {
                  action: 'generate-purchase-order-report',
                  label: 'Generar reporte de ordenes de compra'
                },
                {
                  action: 'change-purchase-order-area',
                  label: 'Cambiar área de orden de compra'
                }
              ]
            },
            {
              component: 'manual-purchase-orders-form',
              label: 'Pedido manual',
              actions: [
                {
                  action: 'create-purchase-order-by-xml',
                  label: 'Crear orden por XML'
                },
                {
                  action: 'create-purchase-order-template',
                  label: 'Crear plantillas de órdenes de compra'
                },
                {
                  action: 'read-purchase-order-template',
                  label: 'Ver plantillas de órdenes de compra'
                },
                {
                  action: 'create-purchase-order-by-products',
                  label: 'Agregar productos a la orden'
                },
                {
                  action: 'create-purchase-order-by-provider-products',
                  label: 'Agregar productos de un proveedor a la orden'
                }
              ]
            },
            {
              component: 'smart-purchase-orders-form',
              label: 'Pedido inteligente',
              actions: [
                {
                  action: 'create-purchase-order-by-stock',
                  label: 'Crear orden de compra inteligente'
                },
                {
                  action: 'create-favorite-purchase-order-product',
                  label: 'Marcar producto como favorito'
                }
              ]
            }
          ]
        },
        {
          module: 'my-management',
          label: 'Administración en el menú lateral',
          components: [
            {
              component: 'add-balance',
              label: 'Agregar saldo',
              actions: [
                {
                  action: 'increase-balance',
                  label: 'Aumentar saldo'
                },
                {
                  action: 'read-scheduled-deposits',
                  label: 'Ver depositos calendarizados'
                },
                {
                  action: 'manage-balance',
                  label: 'Administrar saldo'
                }
              ]
            },
            {
              component: 'purchases-generated-list',
              label: 'Reporte de compras',
              actions: [
                {
                  action: 'export-purchases-report',
                  label: 'Exportar reporte de compras'
                }
              ]
            },
            {
              component: 'movements-list',
              label: 'Movimientos',
              actions: [
                {
                  action: 'export-movements-report',
                  label: 'Exportar reporte de movimientos'
                },
                {
                  action: 'download-xml-zip',
                  label: 'Descarga de XML'
                }
              ]
            }
          ]
        },
        {
          module: 'settings',
          label: 'Ajustes',
          components: [
            {
              component: 'areas',
              label: 'Áreas',
              actions: [
                {
                  action: 'create-area',
                  label: 'Crear área'
                },
                {
                  action: 'update-area',
                  label: 'Actualizar área'
                },
                {
                  action: 'delete-area',
                  label: 'Borrar área'
                }
              ]
            },
            {
              component: 'sections',
              label: 'Secciones',
              actions: [
                {
                  action: 'create-section',
                  label: 'Crear sección'
                },
                {
                  action: 'update-section',
                  label: 'Actualizar sección'
                },
                {
                  action: 'delete-section',
                  label: 'Borrar sección'
                }
              ]
            },
            {
              component: 'users',
              label: 'Usuarios',
              actions: [
                {
                  action: 'create-user',
                  label: 'Crear usuario'
                },
                {
                  action: 'update-user',
                  label: 'Actualizar usuario'
                },
                {
                  action: 'delete-user',
                  label: 'Borrar usuario'
                },
                {
                  action: 'resend-restaurant-invitation',
                  label: 'Reenviar invitación al usuario'
                }
              ]
            },
            {
              component: 'restaurant',
              label: 'Restaurante',
              actions: [
                {
                  action: 'social-network',
                  label: 'Conectar con redes sociales'
                },
                {
                  action: 'change-restaurant-information',
                  label: 'Cambiar información del restaurante'
                },
                // {
                //   action: 'purchase-orders-notification',
                //   label: 'Notificaciones de las ordenes de compra'
                // },
                {
                  action: 'change-restaurant-tax-information',
                  label: 'Cambiar infomación fiscal del restaurante'
                },
                {
                  action: 'delivery-address',
                  label: 'Administrar direcciones de entrega de mercancía'
                }
              ]
            }
          ]
        },
        {
          module: 'expenses',
          label: 'Finanzas',
          components: [
            {
              component: 'bank-accounts',
              label: 'Bancos y cuentas',
              actions: [
                {
                  action: 'create-bank',
                  label: 'Crear banco o caja'
                },
                {
                  action: 'update-bank',
                  label: 'Actualizar banco o caja'
                },
                {
                  action: 'create-bank-account',
                  label: 'Crear cuenta bancaria'
                },
                {
                  action: 'link-bank-account',
                  label: 'Vincular cuenta bancaria'
                }
              ]
            },
            {
              component: 'income-category',
              label: 'Categoría de ingresos',
              actions: [
                {
                  action: 'create-income-category',
                  label: 'Crear categoría de ingreso'
                },
                {
                  action: 'update-income-category',
                  label: 'Actualizar categoría de ingreso'
                },
                {
                  action: 'create-income-concept',
                  label: 'Crear concepto de ingreso'
                },
                {
                  action: 'update-income-concept',
                  label: 'Actualizar concepto de ingreso'
                },
                {
                  action: 'create-income-type',
                  label: 'Crear tipo de ingreso'
                },
                {
                  action: 'update-income-type',
                  label: 'Actualizar tipo de ingreso'
                }
              ]
            },
            {
              component: 'outgoing-category',
              label: 'Categoría de egreso',
              actions: [
                {
                  action: 'create-outgoing-category',
                  label: 'Crear categoría de egreso'
                },
                {
                  action: 'update-outgoing-category',
                  label: 'Actualizar categoría de egreso'
                },
                {
                  action: 'create-outgoing-concept',
                  label: 'Crear concepto de egreso'
                },
                {
                  action: 'update-outgoing-concept',
                  label: 'Actualizar concepto de egreso'
                },
                {
                  action: 'create-outgoing-type',
                  label: 'Crear tipo de egreso'
                },
                {
                  action: 'update-outgoing-type',
                  label: 'Actualizar tipo de egreso'
                }
              ]
            },
            {
              component: 'financial-movements',
              label: 'Movimientos financieros',
              actions: [
                {
                  action: 'create-pay-order',
                  label: 'Crear orden de pago'
                },
                {
                  action: 'add-product-service',
                  label: 'Agregar producto o servicio'
                },
                {
                  action: 'submit-pay-order',
                  label: 'Envíar orden de pago'
                },
                {
                  action: 'download-invoices',
                  label: 'Descargar facturas'
                },
                {
                  action: 'relate-pay-order',
                  label: 'Relacionar orden de compra'
                },
                {
                  action: 'generate-pay-order',
                  label: 'Generar orden de pago'
                },
                {
                  action: 'create-movement',
                  label: 'Crear movimiento'
                },
                {
                  action: 'delete-movement',
                  label: 'Borrar movimiento'
                },
                {
                  action: 'delete-pay-order',
                  label: 'Borrar orden de pago'
                },
                {
                  action: 'create-related-transaction',
                  label: 'Agregar transacción relacionada'
                },
                {
                  action: 'delete-related-transaction',
                  label: 'Borrar transacción relacionada'
                }
              ]
            },
            {
              component: 'payment-methods',
              label: 'Formas de pago',
              actions: [
                {
                  action: 'create-payment-method',
                  label: 'Crear método de pago'
                },
                {
                  action: 'update-payment-method',
                  label: 'Actualizar método de pago'
                }
              ]
            },
            {
              component: 'cash-close',
              label: 'Cortes',
              actions: [
                {
                  action: 'create-cashClose',
                  label: 'Crear corte'
                },
                {
                  action: 'update-cashClose',
                  label: 'Actualizar corte'
                },
                {
                  action: 'validate-status',
                  label: 'Validar corte diario'
                },
                {
                  action: 'validate-definitive-status',
                  label: 'Validar corte sin cancelaciones'
                },
                {
                  action: 'edit-amount',
                  label: 'Editar venta'
                }
              ]
            },
            {
              component: 'billing',
              label: 'Facturación',
              actions: [
                {
                  action: 'create-posSales',
                  label: 'Obtener ventas del mes pasado'
                },
                {
                  action: 'generate-global-invoice',
                  label: 'Generar factura'
                },
                {
                  action: 'update-posSale',
                  label: 'Actualizar venta mostrador'
                },
                {
                  action: 'generate-document',
                  label: 'Generar documento'
                }
              ]
            }
          ]
        }
      ],
      search: ''
    }
  },
  watch: {
    'search': debounce(async function (val) {
      if (val.length >= 2) {
        try {
          const response = await this.$api
            .get(`/v1/restaurants/${this.restaurantId}/users`, { skip: 0, email: `/${val}/i` })
          this.table.data = response.data.sort((a, b) => {
            if (a.name > b.name) return 1
            if (a.name < b.name) return -1
            return 0
          })
          this.table.total = response.total
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        this.load()
      }
    }, 300)
  },
  computed: {
    restaurantId: function () { return this.$store.state.currentRestaurant.data._id || null },
    user () { return this.$store.state.login.user },
    userPermissions () {
      return this.$store.state.login.permissions['settings'].components['users'].actions
    },
    areas () {
      return this.$store.state.currentRestaurant.areas.data
    },
    isEditing () {
      return !!this.form.data._id
    }
  },
  methods: {
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      await this.load({
        limit: data.itemsPerPage,
        skip: (data.itemsPerPage * (data.page - 1)),
        sort: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`,
        'role!': 'provider'
      })
    },
    async load (params = null) {
      this.table.loading = true

      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.page - 1)),
        'role!': 'provider'
      }

      if (this.search) params.email = `/${this.search}/i`

      try {
        const response = await this.$api.get(`/v1/restaurants/${this.restaurantId}/users`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    onCloseCreateDialog: function () {
      if (this.$refs && this.$refs.userForm) this.$refs.userForm.reset()
      this.form.data = {}
      this.permissionsForm['areas-allowed'] = []
      this.createDialog = false
    },
    onOpenUpdateUserDialog: function (user) {
      const cloneUser = cloneDeep(user)
      const permissions = cloneUser.permissions
      delete cloneUser.permissions
      this.form.data = cloneUser
      this.permissionsForm = permissions
      this.createDialog = true
    },
    onOpenRemoveUserDialog: function (user) {
      this.form.data = cloneDeep(user)
      this.removeDialog = true
    },
    onOpenInviteUserDialog: function (user) {
      this.form.data = cloneDeep(user)
      this.inviteDialog = true
    },
    onCloseRemoveDialog: function () {
      this.onCloseCreateDialog()
      this.removeDialog = false
    },
    onCloseInviteDialog: function () {
      this.onCloseCreateDialog()
      this.inviteDialog = false
    },
    submit: async function () {
      if (this.$refs.userForm.validate()) {
        this.overlay = true
        const request = this.form.data.uuid == null
          ? this.create()
          : this.update()
        try {
          await request
          await this.load()
          this.onCloseCreateDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    create: async function () {
      const payload = this.form.data
      payload.permissions = this.permissionsForm
      await this.$api.post(`/v1/restaurants/${this.restaurantId}/users`, payload)
      this.$toasted.show('Se ha creado el usuario con éxito', { duration: 3000 })
    },
    update: async function () {
      const payload = this.form.data
      payload.permissions = this.permissionsForm
      await this.$api.put(`/v1/restaurants/${this.restaurantId}/users/${this.form.data.uuid}`, payload)
      this.$toasted.show('Se ha actualizado el usuario con éxito', { duration: 3000 })
    },
    remove: async function () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/restaurants/${this.restaurantId}/users/${this.form.data.uuid}`)
        await this.load()
        this.onCloseRemoveDialog()
        this.$toasted.show('Se ha eliminado el usuario con éxito', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    invite: async function () {
      this.overlay = true
      try {
        await this.$api.post(`/v1/invitations/${this.form.data.invitation}/resend`)
        await this.load()
        this.onCloseInviteDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    getRole (role) {
      const foundRole = this.roles.find(r => r.value === role)
      return foundRole.text
    },
    getEmployment (employment) {
      const foundEmployment = this.employments.find(r => r.value === employment)
      if (foundEmployment) return foundEmployment.text
      return ''
    },
    checkModule ({ module }, value) {
      Object.keys(this.permissionsForm[module].components).forEach((key) => {
        this.permissionsForm[module].components[key].visible = value
        this.checkComponent({ module, component: key }, value)
      })
    },
    checkComponent ({ module, component }, value) {
      Object.keys(this.permissionsForm[module].components[component].actions).forEach((key) => {
        this.permissionsForm[module].components[component].actions[key] = value
      })
    },
    disableLastOne (area) {
      return (this.permissionsForm['areas-allowed'] || []).includes(area._id) && (this.permissionsForm['areas-allowed'] || []).length === 1
    }
  }
}
</script>

<style lang="css" scoped>
.sticky {
  position: sticky;
  bottom: 0;
}
.scrollable {
  overflow-y: auto;
  max-height: 500px;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
</style>
